export default "__VITE_ASSET__CuvI84DJ__"